import React, { PropsWithChildren, useEffect, useRef } from 'react';
import {
    Dialog,
    DialogPanel,
    Transition,
    TransitionChild,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { isEmbedded } from '~/public/lib/PageHelpers';
import { sendScrollTo } from '~/public/lib/EmbedMessaging';

type ModalProps = {
    isOpen: boolean;
    onClose: () => void;
    widthClass?: string;
    backgroundClassName?: string;
    panelClassName?: string;
    panelContainerClassName?: string;
    alignTop?: boolean;
};
const Modal = ({
    isOpen,
    onClose,
    widthClass,
    children,
    hideClose,
    backgroundClassName,
    panelClassName,
    panelContainerClassName,
    alignTop,
}: PropsWithChildren<ModalProps>) => {
    const panelRef = useRef();

    useEffect(() => {
        setTimeout(() => {
            if (isOpen && isEmbedded() && panelRef.current) {
                console.log('scrolling to panel');
                panelRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest',
                });
                //sendScrollTo(panelRef.current.offsetTop);
            }
        }, 250);
    }, [isOpen, !!panelRef.current]);

    return (
        <Transition show={isOpen}>
            <Dialog className="relative z-50 modal" onClose={onClose}>
                <TransitionChild
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div
                        className={`fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity ${backgroundClassName}`}
                    />
                </TransitionChild>

                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div
                        className={`flex min-h-full items-end sm:items-start justify-center p-4 text-center ${panelContainerClassName}`}
                    >
                        <TransitionChild
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <DialogPanel
                                className={`modal-panel relative transform rounded-[23px] p-6 text-left shadow-xl transition-all sm:my-16 w-full ${widthClass || 'sm:max-w-[600px]'} sm:p-6 ${panelClassName}`}
                                ref={panelRef}
                            >
                                {!hideClose && (
                                    <button
                                        className="btn-gray-link absolute right-5 top-5"
                                        onClick={onClose}
                                    >
                                        <XMarkIcon className="w-5 h-5" />
                                    </button>
                                )}

                                {children}
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default Modal;
